var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEuroIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 13,
    viewBox: "0 0 8 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.92188 11.6094C7.22917 11.9948 6.49479 12.1875 5.71875 12.1875C3.49479 12.1875 2.16927 10.8698 1.74219 8.23438H0.796875V7.14062H1.64062C1.61979 6.97917 1.60938 6.77865 1.60938 6.53906C1.60938 6.28906 1.625 6.00781 1.65625 5.69531H0.796875V4.60156H1.82031C2.08594 3.35156 2.58594 2.375 3.32031 1.67188C4.0599 0.963542 4.95573 0.609375 6.00781 0.609375C6.72135 0.609375 7.35938 0.755208 7.92188 1.04688V2.3125C7.32812 1.90625 6.66146 1.70312 5.92188 1.70312C5.27083 1.70312 4.6901 1.96615 4.17969 2.49219C3.67448 3.01302 3.32031 3.71615 3.11719 4.60156H7V5.69531H2.94531C2.90365 6.21094 2.90104 6.69271 2.9375 7.14062H7V8.23438H3.0625C3.4375 10.1406 4.34896 11.0938 5.79688 11.0938C6.47917 11.0938 7.1875 10.8672 7.92188 10.4141V11.6094Z",
    fill: "#0A0A0A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEuroIcon);
export default __webpack_public_path__ + "static/media/euroIcon.16d94de65bf3924e1d42eeddc1e4d15f.svg";
export { ForwardRef as ReactComponent };